import React, { useRef, useCallback } from 'react';
import { Flex } from '@chakra-ui/react';
import { AiOutlinePlus } from 'react-icons/ai';

import CreateInviteModal from './CreateInviteModal';

import { Modal } from '~/components/UI/Modal';
import { Button } from '~/components/ChakraComponents';

export default function CreateInviteButton({ fetchData }) {
  const createInviteModalRef = useRef(null);

  const openCreateInvite = useCallback(() => {
    createInviteModalRef.current.openModal();
  }, []);

  return (
    <Flex w={['100%', '100%', '100%', '135px']}>
      <Button
        title="criar convite"
        width="100%"
        height="40px"
        onClick={openCreateInvite}
        icon2={<AiOutlinePlus size={24} />}
      />
      <Modal
        title="Criar Convite"
        ref={createInviteModalRef}
        component={CreateInviteModal}
        closeModalCallback={fetchData}
      />
    </Flex>
  );
}
